import React from 'react';
export function StatsSection() {
  const stats = [{
    number: '+20',
    label: 'Años de experiencia en el sector'
  }, {
    number: '+100',
    label: 'Equipos reparados y en servicio'
  }, {
    number: '8+',
    label: 'Marcas líderes cubiertas'
  }, {
    number: '24hs',
    label: 'Tiempo máximo de respuesta'
  }];
  return <section className="py-16 bg-primary relative overflow-hidden" data-id="element-173">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-174">
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" data-id="element-175">
          <defs data-id="element-176">
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-177">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1" data-id="element-178" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" data-id="element-179" />
        </svg>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-180">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4 divide-x-0 lg:divide-x divide-white/10" data-id="element-181">
          {stats.map((stat, index) => <div key={index} className="text-center px-4" data-id="element-182">
              <div className="text-4xl lg:text-5xl font-heading font-bold text-accent mb-2" data-id="element-183">
                {stat.number}
              </div>
              <div className="text-subtitle text-sm lg:text-base font-medium max-w-[180px] mx-auto" data-id="element-184">
                {stat.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}